import cn from 'classnames'
import { Typography } from '../../typography'
import styles from './FormField.module.css'
import { FormFieldProps } from './FormField.types'

export function FormField({
  children,
  disabled,
  status,
  label,
  helpText,
  feedbackText,
  className,
  optionalLabel,
  size = 'Full',
  labelAlignment = 'top',
  name,
  ...props
}: React.PropsWithChildren<FormFieldProps>) {
  const formFieldClassName = cn(
    styles.formFieldWrapper,
    {
      [styles.formFieldDisabled]: disabled,
      [styles.alignmentTop]: labelAlignment === 'top',
      [styles.alignmentLeft]: labelAlignment === 'left',
      [styles.alignmentRight]: labelAlignment === 'right',
      [styles[`size${size}`]]: Boolean(size),
    },
    className,
  )

  return (
    <div className={formFieldClassName} {...props}>
      <div className={styles.header}>
        {label && (
          <div className={styles.labelWrapper}>
            <Typography variant="body-m-regular-tight" as="label" className={styles.label} htmlFor={name}>
              {label}
            </Typography>
            {optionalLabel && (
              <Typography variant="body-s-regular-tight" className={styles.optionalLabel} data-testid="optional-label">
                {optionalLabel}
              </Typography>
            )}
          </div>
        )}
      </div>
      <div className={styles.fieldMain}>
        <div className={styles.controlWrapper}>
          {children}
        </div>
        {feedbackText && status === 'error' && (
          <Typography variant="body-s-regular-tight" className={styles.feedbackText}>
            {feedbackText}
          </Typography>
        )}
        {helpText && helpText.length > 0 && (
          <Typography variant="body-s-regular-tight" className={styles.helpText}>
            {helpText}
          </Typography>
        )}
      </div>
    </div>
  )
}
